// Observes when the side cart changes - refactor
const quickCart = document.querySelector('.quick-cart');

if (quickCart) {

    const observer = new MutationObserver(() => {

        // Initilize complete the look swiper slider

        import(flu.chunks.swiper).then(function (_ref) {

            var Swiper = _ref.Swiper;

            completeTheLookSlider = new Swiper(".complete-the-look-slider", {
                slidesPerView: "auto",
                spaceBetween: 15,
                grabCursor: true,
            });

        });

    });

    observer.observe(quickCart, { subtree: true, childList: true });

}

import(flu.chunks.swiper).then(function (_ref) {

    var Swiper = _ref.Swiper;

    this.completeTheLookSlider = new Swiper(".complete-the-look-slider", {
        slidesPerView: "auto",
        spaceBetween: 15,
        grabCursor: true,
    });

});

// Collage hero mobile slider - HOMEPAGE
// const collageHeroMobileSlider = document.querySelector('.collage-hero-mobile__slider');

// if (collageHeroMobileSlider) {

//     import(flu.chunks.swiper).then(function (_ref) {

//         var Swiper = _ref.Swiper,
//             Autoplay = _ref.Autoplay;
//             EffectFade = _ref.EffectFade;

//         this.collageHeroMobileSlider = new Swiper(".collage-hero-mobile__slider", {
//             modules: [EffectFade, Autoplay],
//             loop: true,
//             autoplay: {
//                 delay: 2000,
//                 disableOnInteraction: false,
//             },
//             speed: 300,
//             effect: 'fade',
//             fadeEffect: {
//                 crossFade: true,
//             },
//         });

//     });

// }

// Collection Slider(s) - HOMEPAGE
const collectionSlider = document.querySelector('.collection-slider');

if (collectionSlider) {

    import(flu.chunks.swiper).then(function (_ref) {

        // var _this3 = this;

        var Swiper = _ref.Swiper,
        Navigation = _ref.Navigation;

        this.collectionSlider = new Swiper(".collection-slider", {
            modules: [Navigation],
            slidesPerView: "auto",
            spaceBetween: 5,
            loop: true,
            breakpoints: {
                767: {
                    slidesPerView: 3,
                    spaceBetween: 5,
                },
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

    });

}


// PAIRS WELL WITH FUNCTIONALITY
function appendVariants(colors) {

    // console.log('Append Variants - Colors:', colors);

    document.querySelectorAll('.complimentary-product').forEach(product => {

        const variants = product.querySelectorAll('.variant-data');
        const appendedColors = new Set();

        variants.forEach(v => {

            const variantColor = v.dataset.variantColor;

            if (colors.includes(variantColor) && !appendedColors.has(variantColor)) {

                appendedColors.add(variantColor);

                const clone = product.cloneNode(true);
                clone.classList.add('variant-clone');

                clone.querySelector('.complimentary-image').src = v.dataset.variantImage;
                clone.querySelector('.complimentary-price').textContent = v.dataset.variantPrice;
                clone.querySelector('.complimentary-link').href = v.dataset.variantUrl;

                product.parentElement.appendChild(clone);

            }

        });

    });

    // Display only appended variants
    document.querySelectorAll('.variant-clone')
        .forEach(el => el.style.display = "block");

}

function removeAppendedVariants() {
    document.querySelectorAll('.variant-clone').forEach(el => el.remove());
}

// Update Pairs Well products after variant change
function updateComplimentaryProducts(color, sku) {

    // console.log('Match to Color: ' + color);

    document.querySelectorAll('.complimentary-product').forEach(product => {

        product.style.display = '';

        const variants = product.querySelectorAll('.variant-data');
        let match = null;

        match = [...variants].find(v => v.dataset.variantColor === color);

        // console.log('match: ' + match);

        // If no match, clear products
        if (!match) {
            // console.log('No matching variant found for color:', color, 'in product:', product);
            product.style.display = 'none';
            return;
        }

        product.querySelector('.complimentary-image').src = match.dataset.variantImage;
        product.querySelector('.complimentary-price').textContent = match.dataset.variantPrice;
        product.querySelector('.complimentary-link').href = match.dataset.variantUrl;

    });

    // handle special color rule for La Leopardo
    if (color === 'la leopardo') {
        if (sku === 'RX7642-7819') {
            // console.log('Poppi Leo');
            appendVariants(['onyx', 'french latte']);
        } else {
            appendVariants(['onyx']);
        }
    } else {
        removeAppendedVariants();
    }

}

document.addEventListener("product:variant-change", function (evt) {
    const selectedColor = event.detail.variant.options[0].toLowerCase();
    const sku = event.detail.variant.sku;
    updateComplimentaryProducts(selectedColor, sku);
});

const complimentaryProducts = document.querySelector('#complimentary-products');

if (complimentaryProducts) {
    const selectedColor = complimentaryProducts.dataset.selectedColor;
    const selectedSku = complimentaryProducts.dataset.selectedSku;
    updateComplimentaryProducts(selectedColor, selectedSku);
}


